const {atom} = require('jotai');

export const hasReadNoticeAtom = atom(false);
